import type { SportFilter } from "../Games/MatchCards/types";

export type MatchesHubTab = "live" | "finished";

export function parseMatchesHubTab(raw: string | null | undefined): MatchesHubTab {
    return raw === "finished" ? "finished" : "live";
}

/** Matches hub sport slug for URL query params — always explicit (including cricket). */
export function matchesHubSportSlug(sport?: Exclude<SportFilter, null> | string | null): string {
    const s = (sport ?? "CRICKET").toString().toUpperCase();
    if (s.includes("HORSE")) return "horses";
    if (s.includes("FOOT")) return "football";
    if (s.includes("TENNIS")) return "tennis";
    return "cricket";
}

/** `sport=cricket` query pair for matches hub / match-detail URLs. */
export function matchesHubSportSearchParam(sport?: Exclude<SportFilter, null> | string | null): string {
    return `sport=${encodeURIComponent(matchesHubSportSlug(sport))}`;
}

/** Match hub results page for a finished fixture (all sports). */
export function buildMatchCompleteHref(matchId: string, sport?: Exclude<SportFilter, null> | string | null): string {
    return `/matches?id=${encodeURIComponent(String(matchId))}&${matchesHubSportSearchParam(sport)}&status=complete`;
}

/** Back link to the matches hub, preserving sport and LIVE/FINISHED tab. */
export function buildMatchesListHref(options?: {
    sport?: Exclude<SportFilter, null> | null;
    tab?: MatchesHubTab;
}): string {
    const params = new URLSearchParams();
    params.set("sport", matchesHubSportSlug(options?.sport));
    if (options?.tab === "finished") {
        params.set("tab", "finished");
    }
    return `/matches?${params.toString()}`;
}

/** Carry matches hub tab through match detail URLs so back navigation can restore it. */
export function withMatchesHubTab(href: string, tab: MatchesHubTab): string {
    if (tab !== "finished") return href;
    if (href.includes("tab=")) return href;
    const joiner = href.includes("?") ? "&" : "?";
    return `${href}${joiner}tab=finished`;
}
